"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPERSONATION_OFFICE_ITEM_KEY = exports.IMPERSONATION_ITEM_KEY = void 0;
exports.IMPERSONATION_ITEM_KEY = 'sc::impersonating_user';
exports.IMPERSONATION_OFFICE_ITEM_KEY = 'sc::impersonating_office';
